import type { TranslationTag } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import { ImplyRunnerFailureCode } from '@ps/web-sports-api-types';
import classNames from 'clsx';
import React from 'react';

import { Icon } from '@swf/sports/components/Icon/Icon';

import {
  TXTWCL_This_bet_cannot_be_placed_due__ELL,
  TXTWCL_You_need_to_add_one_or_more_se_ELL
} from './BetBuilderError.messages.json';
import styles from './BetBuilderError.scss';

export interface Props {
  failureCode: ImplyRunnerFailureCode;
  className?: string;
}

const impossibleOutcomeFailureCodes: ImplyRunnerFailureCode[] = [
  ImplyRunnerFailureCode.INVALID_SGM_COMBINATION,
  ImplyRunnerFailureCode.IMPOSSIBLE_SAME_MARKET_COMBINATION
];
const guaranteedOutcomeFailureCode = ImplyRunnerFailureCode.INVALID_SGM_COMBINATION_SINGLE_ODDS;

const BetBuilderError: React.FC<Props> = ({ failureCode, className }) => {
  let errorTranslationTag: TranslationTag | undefined;

  if (impossibleOutcomeFailureCodes.includes(failureCode)) {
    errorTranslationTag = TXTWCL_This_bet_cannot_be_placed_due__ELL;
  }

  if (failureCode === guaranteedOutcomeFailureCode) {
    errorTranslationTag = TXTWCL_You_need_to_add_one_or_more_se_ELL;
  }

  if (errorTranslationTag) {
    return (
      <div className={classNames(styles.container, className)}>
        <Icon name="error" size="x2" className={styles.icon} />
        <Translation {...errorTranslationTag} />
      </div>
    );
  }

  return null;
};

export default BetBuilderError;
